// extracted by mini-css-extract-plugin
export var main = "PageLayout-module--main--rxmdc";